// TIP-609 — the four status chips, with the design's own two pieces of motion:
// the pulsing dot on Request received, and the nodding indicator on Building
// your brief.
//
// Request received and Building your brief open the status modal. Ready is not
// clickable and carries a Download button beside it instead.
//
// TIP-609 fix: Snag. Credit returned IS clickable and shows the analyst's
// reason. In the design it is a plain chip with no explanation anywhere on the
// customer side (inconsistency 7), so a brief disappears and the customer is
// never told why.
import React from "react";
import "./counterpartyBriefs.css";
import { BRIEF_STATUSES, TABLE_COPY } from "./briefsFixtures";

const VARIANT = {
  [BRIEF_STATUSES.RECEIVED]: "received",
  [BRIEF_STATUSES.BUILDING]: "building",
  [BRIEF_STATUSES.READY]: "ready",
  [BRIEF_STATUSES.SNAG]: "snag",
};

const CLICKABLE = [BRIEF_STATUSES.RECEIVED, BRIEF_STATUSES.BUILDING, BRIEF_STATUSES.SNAG];

const Glyph = ({ status }) => {
  if (status === BRIEF_STATUSES.RECEIVED) {
    return (
      <span className="cb-chip-glyph">
        <span className="cb-chip-pulse" />
      </span>
    );
  }
  if (status === BRIEF_STATUSES.BUILDING) {
    return (
      <span className="cb-bot" aria-hidden="true">
        <span className="cb-bot-stalk" />
        <span className="cb-bot-antenna" />
        <span className="cb-bot-body">
          <span className="cb-bot-scan">
            <span className="cb-bot-eye" />
            <span className="cb-bot-eye" />
          </span>
        </span>
      </span>
    );
  }
  if (status === BRIEF_STATUSES.READY) {
    return <span className="cb-chip-check">&#10003;</span>;
  }
  return null;
};

// `busy` is the row's own request, not the table's: with four ready briefs
// only the one that was clicked reports itself working. Disabled while it is
// out, so a second click cannot start the same download twice.
export const DownloadButton = ({ onClick, busy = false }) => (
  <button
    type="button"
    className="cb-download"
    onClick={onClick}
    disabled={busy}
    aria-busy={busy || undefined}
  >
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M7 1.5v7.2m0 0L4.3 6M7 8.7 9.7 6M2 10.5v1.2a.8.8 0 0 0 .8.8h8.4a.8.8 0 0 0 .8-.8v-1.2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    {busy ? TABLE_COPY.downloading : TABLE_COPY.download}
  </button>
);

const StatusChip = ({ status, onClick }) => {
  const className = `cb-chip cb-chip--${VARIANT[status]}`;
  const body = (
    <>
      <Glyph status={status} />
      <span>{status}</span>
    </>
  );

  if (!CLICKABLE.includes(status)) return <span className={className}>{body}</span>;

  return (
    <button type="button" className={className} onClick={onClick} title={TABLE_COPY.chipTooltip}>
      {body}
    </button>
  );
};

export default StatusChip;
